import * as React from 'react';
import * as styles from './styles.css';

import { Text } from '../Text';
import { Container } from '../Container';

import { ListItem } from './ListItem';

import { DATA } from './data';

import { ActionWithHorizontalScroll } from '../ActionWithHorizontalScroll';
import { trackSwipe, EBlocks } from '../../analytics';

export function ProductYourNeeds() {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <Text size="h2" color="white" bold>
          Подберите продукт под свои нужды
        </Text>
      </div>
      <Container>
        <div className={styles['block']}>
          <div className={styles['content']}>
            <div className={styles['header']}>
              <Text size="h3" bold>
                Данные
              </Text>
            </div>
            <div className={styles['description']}>
              <Text>
                Данные в одном источнике и одной структуре содержат историю жизни каждого объявления. Глубина архива 3
                года. Для Москвы, СПБ и их областей – 5 лет
              </Text>
            </div>
            <ActionWithHorizontalScroll action={() => trackSwipe(EBlocks.PickUpProduct)}>
              <div className={styles['items']}>
                {DATA.map((item, index) => {
                  const { title, afterTitle, subTitle, list, icon } = item;

                  return (
                    <ListItem
                      key={index}
                      title={title}
                      afterTitle={afterTitle}
                      subTitle={subTitle}
                      list={list}
                      icon={icon}
                    />
                  );
                })}
              </div>
            </ActionWithHorizontalScroll>
          </div>
          <Text size="verySmall" color="gray">
            * Совместно с Dataflat
          </Text>
        </div>
      </Container>
    </div>
  );
}
